import React from 'react';
import PropTypes from 'prop-types';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Card,
} from '@mui/material';
import '../Common.css';
import { Grey3 } from '../../../color_utils';

const ActionBox = ({ items, sx }) => (
    <Card variant="outlined" className='action-items' sx={{ borderColor: "#EBEDF8", ...sx }}>
        <List dense>
            {items.map(({ Icon, title, onClick, component, href }, index) => (
                <ListItem className='action-items-item'
                    disablePadding
                    key={index}
                    onClick={onClick}
                    component={component}
                    href={href}
                >
                    <ListItemButton>
                        <ListItemIcon>
                            <Icon style={{ color: Grey3 }} />
                        </ListItemIcon>
                        <ListItemText
                            primary={title}
                            primaryTypographyProps={{
                                sx: {
                                    fontSize: { xs: '14px', lg: '0.75rem' },
                                }
                            }}
                        />
                    </ListItemButton>
                </ListItem>
            ))}
        </List>
    </Card>
);

ActionBox.propTypes = {
    items: PropTypes.array.isRequired,
    sx: PropTypes.object
};

ActionBox.defaultProps = {
    sx: {}
};

export default ActionBox;
